"use client";

import React from "react";
import { Button, Typography } from "@drpcrd/shared/ui";
import { FileIcon, ImageIcon, X } from "lucide-react";

type ChatLocalFileListProps = {
  files?: FileList;
  onRemoveFile: (index: number) => void;
  className?: string;
};

/**
 * Component for displaying and managing locally uploaded files in chat
 */
export const ChatLocalFileList = ({
  files,
  onRemoveFile,
  className,
}: ChatLocalFileListProps) => {
  if (!files || files.length === 0) {
    return null;
  }

  return (
    <div className={`mb-1 flex flex-wrap gap-0.5 ${className || ""}`}>
      {Array.from(files).map((file, index) => (
        <div
          key={`${file.name}-${index}`}
          className="shadow-xs bg-card flex items-center gap-0.5 rounded-xl border px-1.5 py-1"
        >
          {file.type.startsWith("image/") ? (
            <ImageIcon size={16} />
          ) : (
            <FileIcon size={16} />
          )}
          <Typography truncate size="xs" className="max-w-32">
            {file.name}
          </Typography>
          <Button
            onClick={() => onRemoveFile(index)}
            variant="text"
            className="py-0"
          >
            <X size={16} />
          </Button>
        </div>
      ))}
    </div>
  );
};
